export const SERVICES_URL = process.env.REACT_APP_SERVICES_URL
export const SERVICES_ANON_KEY = process.env.REACT_APP_SERVICES_ANON_KEY